import { createFileRoute } from '@tanstack/react-router';
import { MenuTitle } from '../../types';

export const trendingStaticData = {
  menuTitle: MenuTitle.TrendingInfluencers
};
export const Route = createFileRoute('/_private-routes/trending')({
  staticData: trendingStaticData
});
